module.exports = __webpack_public_path__ + "static/media/bird-budgie2.dc2220a5.aac";